var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabaseSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.66667V15.8333C4 17.8592 7.2835 19.5 11.3333 19.5C15.3832 19.5 18.6667 17.8592 18.6667 15.8333V6.66667M4 6.66667C4 8.6925 7.2835 10.3333 11.3333 10.3333C15.3832 10.3333 18.6667 8.6925 18.6667 6.66667M4 6.66667C4 4.64083 7.2835 3 11.3333 3C15.3832 3 18.6667 4.64083 18.6667 6.66667M18.6667 11.25C18.6667 13.2758 15.3832 14.9167 11.3333 14.9167C7.2835 14.9167 4 13.2758 4 11.25",
    stroke: "#717680",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseSvg);
export default __webpack_public_path__ + "static/media/DatabaseSvg.b5c8f4a0d18c0fd3654d8e9a77e96a96.svg";
export { ForwardRef as ReactComponent };